module.exports = __webpack_public_path__ + "img/phone.21371a5c.svg";